<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>飞艇配置</span>
          <CommonExport :import-p="'config:airShip2:import'" :export-p="'config:airShip2:export'" :get-table="getTables" :import-method="importAirship2Cfg" :export-method="exportAirship2Cfg" />
          <clear-cache-apply />
          <sync-data />
        </div>

        <el-table :data="formData" border stripe>
          <el-table-column prop="levelId" label="等级">
            <template slot-scope="scope">
              <el-input v-model.number="scope.row.levelId" placeholder="等级" />
            </template>
          </el-table-column>

          <el-table-column prop="speed" label="速度">
            <template slot-scope="scope">
              <el-input v-model.number="scope.row.speed" placeholder="速度" />
            </template>
          </el-table-column>

          <el-table-column prop="conf" label="奖励" width="800px">
            <template slot-scope="scope">
              {{ getReward(scope.row.conf) }}
            </template>
          </el-table-column>

          <el-table-column prop="max_exchange" label="配置">
            <template slot-scope="scope">
              <el-button type="text" @click="dialogVisibleArr[scope.$index].visible = true">配置</el-button>
              <el-drawer
                title="奖励配置"
                :visible.sync="dialogVisibleArr[scope.$index].visible"
                size="600px"
                :before-close="(v)=>{return handleClose(v, scope.$index)}"
              >
                <el-form :inline="true">
                  <el-row v-for="(conf,i) in scope.row.conf" :key="i">
                    <el-form-item label="数量">
                      <el-input v-model.number="conf.num" style="width: 100px;" placeholder="数量" />
                    </el-form-item>

                    <el-form-item label="金币">
                      <el-input v-model.number="conf.money" style="width: 100px;" placeholder="金币" />
                    </el-form-item>

                    <el-form-item label="权重">
                      <el-input v-model.number="conf.v" style="width: 100px;" placeholder="权重" />
                    </el-form-item>
                    <el-form-item>
                      <el-button v-permisaction="['config:airShip2:del']" type="danger" @click="delReward(scope.$index, i)">删除</el-button>
                    </el-form-item>
                  </el-row>
                  <el-button v-permisaction="['config:airShip2:add']" style="margin-top: 10px;" type="primary" @click="addReward(scope.$index)">+</el-button>
                </el-form>
                <span slot="footer" class="dialog-footer">
                  <el-button @click="dialogVisibleArr[scope.$index].visible = false">取 消</el-button>
                  <el-button type="primary" @click="dialogVisibleArr[scope.$index].visible = false">确 定</el-button>
                </span>
              </el-drawer>
            </template>
          </el-table-column>

          <el-table-column>
            <template slot-scope="scope">
              <el-button v-permisaction="['config:airShip2:del']" type="danger" @click="del(scope.row.levelId)">删除</el-button>
            </template>
          </el-table-column>

        </el-table>

        <div style="text-align: center;margin-top: 10px">
          <el-button v-permisaction="['config:airShip2:add']" type="primary" @click="add()">+</el-button>
          <el-button v-permisaction="['config:airShip2:add']" type="primary" @click="onSubmit()">保存</el-button>
        </div>

        <pagination
          v-show="total>0"
          background
          :page.sync="queryParams.pageIndex"
          :limit.sync="queryParams.pageSize"
          :total="total"
          @pagination="getTables"
        />
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import CommonExport from '@/components/CommonExport/index.vue'
import { getToken } from '@/utils/auth'
import {
  delAirship2Cfg,
  exportAirship2Cfg,
  getAirship2CfgList,
  importAirship2Cfg,
  updateAirship2Cfg
} from '@/api/config/airship2'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'
import SyncData from '@/components/syncData/index.vue'
export default {
  name: 'Airship2',
  components: {
    SyncData,
    ClearCacheApply,
    CommonExport
  },
  data() {
    return {
      dialogVisibleArr: [{ visible: false }],
      total: 0,
      headers: { 'Authorization': 'Bearer ' + getToken() },
      sys_app_logoAction: process.env.VUE_APP_BASE_API + '/api/v1/public/uploadFile',
      queryParams: {
        pageIndex: 1,
        pageSize: 10
      },
      propsId: 14,
      formData: [
        {
          'levelId': 0,
          'speed': 10,
          'conf': [
            {
              num: 0,
              money: 0,
              v: 0
            }
          ]
        }
      ]
    }
  },
  created() {
    this.getTables()
  },
  methods: {
    exportAirship2Cfg,
    importAirship2Cfg,
    onSubmit() {
      for (const i in this.formData) {
        const _data = this.formData[i]
        if (_data.levelId <= 0) {
          this.msgError('等级ID不能是0')
          return
        }

        if (_data.speed <= 0) {
          this.msgError('速度不能是0')
          return
        }
      }
      const data = JSON.stringify(this.formData)
      if (data.length < 1) {
        this.msgError('没有需要提交的数据')
        return
      }
      updateAirship2Cfg({ data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      this.formData = []
      getAirship2CfgList(this.queryParams).then(res => {
        this.formData = res.data.list
        this.total = res.data.count
        res.data.list.forEach(item => {
          this.dialogVisibleArr.push({ visible: false })
        })
      })
    },
    add() {
      const levelId = this.total + 1
      this.formData.push({
        'levelId': levelId,
        'speed': 0,
        'conf': []
      })
      this.dialogVisibleArr.push({ visible: false })
    },
    del(id, index) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delAirship2Cfg({ id: id }).then(res => {
          if (res.code === 200) {
            this.msgSuccess(res.msg)
            this.getTables()
          } else {
            this.msgError(res.msg)
          }
        })
      })
    },
    handleClose(done, index) {
      this.dialogVisibleArr[index].visible = false
    },
    addReward(index) {
      this.formData[index].conf.push({
        num: 0,
        money: 0,
        v: 0
      })
    },
    delReward(index, i) {
      this.formData[index].conf = this.formData[index].conf.filter((item, key) => {
        return i !== key
      })
    },
    getReward(conf) {
      const reward = []
      conf.forEach(item => {
        reward.push(`数量:${item.num},金币:${item.money},权重:${item.v}`)
      })
      return reward.join(',')
    }
  }
}
</script>

<style scoped>
</style>
